import { useRef } from 'react';
import { motion, useReducedMotion, useScroll, useTransform } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';
import { Reveal, Chapter } from './StartShared';

export const StartClinic = ({ copy }) => {
  const ref = useRef(null);
  const reduced = useReducedMotion();
  const { scrollYProgress } = useScroll({ target: ref, offset: ['start end', 'end start'] });
  const scale = useTransform(scrollYProgress, [0, 1], [1.06, 1]);
  return (
    <section id="klinik" className="start-clinic start-light" aria-labelledby="clinic-heading" data-testid="start-clinic">
      <div className="start-container">
        <Chapter number="03" label={copy.clinic.label} id="clinic-heading" />
        <Reveal className="start-section-intro">
          <p className="start-display" data-testid="start-clinic-title">{copy.clinic.title[0]}<br /><span className="start-muted">{copy.clinic.title[1]}</span></p>
          <p className="start-intro-text" data-testid="start-clinic-description">{copy.clinic.text}</p>
        </Reveal>
        <div className="start-clinic-layout">
          <figure ref={ref} className="start-clinic-figure">
            <div className="start-clinic-image"><motion.img style={reduced ? undefined : { scale }} src="/images/optimized/DionHairClinic_OP_Raum.webp" alt={copy.clinic.imageAlt} loading="lazy" width="1200" height="800" data-testid="start-clinic-image" /></div>
            <figcaption className="start-mono" data-testid="start-clinic-caption">{copy.clinic.caption}<span>MG / DE</span></figcaption>
          </figure>
          <div className="start-clinic-values">
            {copy.clinic.details.map(([title, text], index) => (
              <Reveal key={title} delay={index * 0.06}>
                <div className="start-clinic-value" data-testid={`start-clinic-value-${index}`}><span className="start-mono">0{index + 1}</span><div><h3>{title}</h3><p>{text}</p></div></div>
              </Reveal>
            ))}
            <a href="/#kontakt" className="start-text-link" data-testid="start-clinic-consultation">{copy.clinic.cta}<ArrowUpRight size={18} aria-hidden="true" /></a>
          </div>
        </div>
      </div>
    </section>
  );
};